import { useMutation, useQueryClient } from 'react-query';
import { useTranslation } from 'react-i18next';
import { errorMessage, successMessage } from '@api/messages';
import postFiles from '../api';

export default function usePostFiles(
  setModalOpen: (isOpen: boolean) => void,
  setModalErrorMessage: (message: string | null) => void,
  setIsSubmitDisabled: (isDisabled: boolean) => void,
  triggerUploadsTableRefresh: (uploadsTableRefresh: boolean) => void
) {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const { mutate } = useMutation((files: File[]) => postFiles(files), {
    onSuccess: () => {
      successMessage({
        title: t('success.uploading.fileset'),
        message: null,
      });
      setIsSubmitDisabled(false);
      setModalOpen(false);
      setModalErrorMessage(null);
      queryClient.invalidateQueries('getProperties');
      triggerUploadsTableRefresh(true);
    },
    onError: (error: any) => {
      setIsSubmitDisabled(false);
      setModalErrorMessage(error?.response?.data);
      errorMessage({
        title: t('error.uploading.fileset'),
        message: null,
        error,
      });
    },
  });
  return mutate;
}
